import { render, staticRenderFns } from "./AddressItem.vue?vue&type=template&id=0c9f6a73&scoped=true&"
import script from "./AddressItem.vue?vue&type=script&lang=js&"
export * from "./AddressItem.vue?vue&type=script&lang=js&"
import style0 from "./AddressItem.vue?vue&type=style&index=0&id=0c9f6a73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9f6a73",
  null
  
)

export default component.exports